import { useBreakpointValue } from "@chakra-ui/react";

function MobileOnlyContent({ children }) {
  const isMobile = useBreakpointValue({ base: true, md: false }); // Display on mobile only (base)
  return isMobile ? children : null;
}

export default MobileOnlyContent;
